import {useQuery} from "@tanstack/react-query";
import {readExchangeType2SelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 환율 지정 조건 2 select hook
 * @param props
 * @returns
 */
export const useReadExchangeType2SelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readExchangeType2SelectBox"],
        queryFn: async () => await readExchangeType2SelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
